
import { CtaSection as GenericCtaSection } from "@/components/ui/cta-section";

export const CtaSection = () => {
  return (
    <GenericCtaSection
      title="Ready to secure your Microsoft 365 environment?"
      description="Get started with a free security assessment and discover how we can help protect your organization."
      buttonText="Schedule a Consultation"
      buttonVariant="cta"
      bgColor="gradient"
      textColor="white"
      useContactModal={true}
      modalTitle="Microsoft 365 Security Assessment"
      modalDescription="Let's discuss your Microsoft 365 security needs. Fill out the form below and our experts will contact you to schedule your free assessment."
      modalFormId="1696a603-03f3-486d-aed9-36414a01ba23"
      additionalFields={{ 
        lead_source: "Website",
        lead_interest: "Microsoft 365 Security",
        service_interest: "Security Assessment"
      }}
    />
  );
};
